import React from 'react';
import {
  AdFormatter,
  AdsetFormatter,
  CampaignFormatter,
  UrlFormatter,
} from 'components/tables/NinjaTable/formatters/sourceFormatters';

const TrafficLevelColumn = {
  url: {
    key: 'ninja_url',
    name: 'URL',
    renderCell: ({ row }) => {
      return <UrlFormatter row={{ url: row.ninja_url }} />;
    },
  },
  ad: {
    key: 'ad',
    name: 'Ad',
    renderCell: ({ row }) => {
      return <AdFormatter row={row?.ninja_url} />;
    },
  },
  adset: {
    key: 'adset',
    name: 'Adset',
    renderCell: ({ row }) => {
      return <AdsetFormatter row={row?.ninja_url?.ad} />;
    },
  },
  campaign: {
    key: 'campaign',
    name: 'Campaign',
    renderCell: ({ row }) => {
      return <CampaignFormatter row={row?.ninja_url?.ad?.adset} />;
    },
  },
};

export default TrafficLevelColumn;
